import TABLE_NAME from "@/config/table.env";
import { baoCaoGiaoDucService } from "@/services/giaoduc/baoCaoGiaoDuc.service";

const tableName = TABLE_NAME.GD_BAOCAOGD;

const actions = {
    async getCustomBaoCaoGD({ dispatch }, { params }) {
        // Lấy tên file mặc định từ params
        let excelNameDefault = params.excelName;
        delete params.excelName;

        try {
            // Gọi API để lấy file Excel dưới dạng blob
            const resp = await baoCaoGiaoDucService.getExportExcel(params, tableName, {
                responseType: "blob", // Đảm bảo API trả về blob
            });

            if (resp) {
                // Tạo URL từ blob
                const url = window.URL.createObjectURL(resp);

                // Tạo timestamp hiện tại
                const timestamp = new Date().toISOString().replace(/[-:.]/g, "").slice(0, 15);

                // Đặt tên file kết hợp excelNameDefault và timestamp
                const fileName = `${excelNameDefault || "bao_cao"}_${timestamp}.xlsx`;

                // Tạo thẻ <a> để tải file
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName); // Đặt tên file tải về
                document.body.appendChild(link);
                link.click();

                // Dọn dẹp
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                return true; // Trả về trạng thái thành công
            } else {
                console.error("Không có dữ liệu phản hồi từ API.");
                dispatch("alert/error", "Không có dữ liệu phản hồi từ API", { root: true });
                return false;
            }
        } catch (error) {
            console.error("Lỗi trong quá trình lấy báo cáo:", error.message);
            dispatch("alert/error", "Có lỗi trong quá trình lấy báo cáo", { root: true });
            return false;
        }
    },
};

export const baoCaoGD = {
    namespaced: true,
    actions,
};
